import resource from '../resource'
import getDataFromStorage from '@/helpers/getDataFromStorage'

const endpoints = {
  validateVoter: '/evote/voting/validate',
  insertPhoneNumber: '/evote/voting/insertPhoneNumber',
  validateOtp: 'evote/voting/checkOtp',
  candidate: 'evote/voting/candidate',
  insertVote: '/evote/voting/insertvote',
  resultVote: '/evote/voting/result',
  publicCandidate: '/evote/voting/candidate/public',
  resultVoteGeneral: '/evote/voting/result/final'
}

export default {
  validateVoter: () => {
    const request = resource.post(`${endpoints.validateVoter}`)
    return request
  },
  insertPhoneNumber: (data = { kode_negara: '', no_telp: '' }) => {
    const request = resource.post(`${endpoints.insertPhoneNumber}`, data)
    return request
  },
  validateOtp: (data = { otp: '' }) => {
    const request = resource.post(`${endpoints.validateOtp}`, data)
    return request
  },
  candidates: () => {
    const {
      tokenCurrent: token,
      tokenVote,
      deviceInfo,
      appVersion,
      apiVersion,
      platform,
    } = getDataFromStorage()
    const request = resource.get(endpoints.candidate, {
      headers: {
        Authorization: `Bearer ${token}`,
        'X-EVOTE-TOKEN-VOTER': tokenVote+"11212" ?? '',
        'X-UIC-DEVICE': deviceInfo ?? '',
        'X-UIC-VERSION': appVersion ?? '',
        'X-API-VERSION': apiVersion ?? '',
        'X-UIC-PLATFORM': platform ?? '',
      },
    })
    return request
  },
  publicCandidates: () => {
    const {
      VUE_APP_X_UIC_VERSION,
      VUE_APP_X_API_VERSION,
      VUE_APP_X_UIC_PLATFORM,
      VUE_APP_X_UIC_DEVICE,
    } = process.env
    const request = resource.get(endpoints.publicCandidate, {
      headers: {
        'X-UIC-VERSION': VUE_APP_X_UIC_VERSION,
        'X-API-VERSION': VUE_APP_X_API_VERSION,
        'X-UIC-PLATFORM': VUE_APP_X_UIC_PLATFORM,
        'X-UIC-DEVICE': VUE_APP_X_UIC_DEVICE,
      },
    })
    return request
  },
  insertVote: (data = { candidate_id: NaN, election_id: NaN }) => {
    const {
      tokenCurrent: token,
      tokenVote,
      deviceInfo,
      appVersion,
      apiVersion,
      platform,
    } = getDataFromStorage()
    const request = resource.post(`${endpoints.insertVote}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        'X-EVOTE-TOKEN-VOTER': tokenVote ?? '',
        'X-UIC-DEVICE': deviceInfo ?? '',
        'X-UIC-VERSION': appVersion ?? '',
        'X-API-VERSION': apiVersion ?? '',
        'X-UIC-PLATFORM': platform ?? '',
      },
    })
    return request
  },
  resultVote: () => {
    const request = resource.post(`${endpoints.resultVote}`)
    return request
  },
  resultVoteGeneral: () => {
    const request = resource.post(`${endpoints.resultVoteGeneral}`)
    return request
  },
}
